import i18n from 'modules/core/lib/i18n'

export const translations = () => ({
  header: i18n.t('contract_versions.flows.update.steps.work_hours.header'),
  hours: i18n.t('contract_versions.flows.update.steps.work_hours.hours.label'),
  max_legal_yearly_hours: i18n.t(
    'contract_versions.flows.update.steps.work_hours.max_legal_yearly_hours.label'
  ),
  maximum_weekly_hours: i18n.t(
    'contract_versions.flows.update.steps.work_hours.maximum_weekly_hours.label'
  ),
  frequency: i18n.t('contract_versions.flows.update.steps.work_hours.frequency.label'),
  days: i18n.t('contract_versions.flows.update.steps.work_hours.days.label'),
  bank_holidays_treatment: i18n.t(
    'contract_versions.flows.update.steps.work_hours.bank_holiday_treatment.label'
  ),
  workable: i18n.t(
    'contract_versions.flows.update.steps.work_hours.bank_holiday_treatment.workable'
  ),
  non_workable: i18n.t(
    'contract_versions.flows.update.steps.work_hours.bank_holiday_treatment.non_workable'
  ),
  working_time_percentage_in_cents: i18n.t(
    'contract_versions.flows.update.steps.work_hours.working_time_percentage.label'
  ),
  working_time_percentage_placeholder: i18n.t(
    'contract_versions.flows.update.steps.work_hours.working_time_percentage.placeholder'
  ),
  period: i18n.t('contract_versions.flows.update.steps.work_hours.frequency.period'),
  enter: i18n.t('contract_versions.flows.update.steps.work_hours.placeholder.enter'),
  max_annual_hours: i18n.t(
    'contract_versions.flows.update.steps.work_hours.max_annual_hours.label'
  ),
  max_weekly_hours: i18n.t(
    'contract_versions.flows.update.steps.work_hours.max_weekly_hours.label'
  ),
  annual_working_time_distribution: i18n.t(
    'contract_versions.flows.update.steps.work_hours.annual_working_time_distribution.label'
  ),
  employment_type: i18n.t('contract_versions.flows.update.steps.work_hours.employment_type.label'),
})
